import { Component, OnDestroy, OnInit } from "@angular/core";
import { from, Subscription } from "rxjs";
import { AuthService } from "../../../core/auth/auth.service";
import { BaseComponent } from "../../../_components/base/base.component";

@Component({
  selector: "app-auth-callback",
  imports: [],
  providers: [],
  templateUrl: "./auth-callback.component.html",
  styleUrl: "./auth-callback.component.scss",
})
export class AuthCallbackComponent extends BaseComponent implements OnInit {
  constructor(private _authService: AuthService) {
    super();
  }

  ngOnInit(): void {
    this.subscriptions.push(from(this._authService.userManager.signinCallback()).subscribe());
  }
}
